import React from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

interface TipsSliderProps {
  items: any[];
  imageTypeLabel: string;
  imageType: string;
  startCapture: (imageType: string) => void;
  back: () => void;
}

const TipsSlider = ({ items, imageTypeLabel, imageType, startCapture, back }: TipsSliderProps) => {

  return <React.Fragment>
    <div id="tipsSliderParent">
      <div className="tips-slider-header">
        <button className="back-btn" onClick={back}><i className="fas fa-arrow-left"></i></button>
        <div className="tips-slider-step">{imageTypeLabel}</div>
      </div>
      <OwlCarousel
        className="m-0 owl-theme"
        id="carouselContainer"
        items={1}
        autoplay={true}
        dotsEach={1}
        autoplayTimeout={3000}
        loop={true}
        autoplaySpeed={1000}
        nav={true}
        navText={['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>']}
      >
        {
          items.map((item, index) =>
            <div className="carouselItem" key={index}>
              <div className="position-relative text-center">
                <img className="itemImg" src={item.imgUrl} />
              </div>
              <div className="itemDescription">{item.description}</div>
            </div>
          )
        }
      </OwlCarousel>
      <button className="btn btn-primary scan-btn-mobile" onClick={() => startCapture(imageType)}>Start Scan</button>
    </div>
  </React.Fragment>
}

export default TipsSlider;
